import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'cpd-chat-header',
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule, FontAwesomeModule],
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss']
})
export class ChatHeaderComponent {
  @Input() public isFullScreen = false;
  /**
   * S.6. The line under "Ask Via". The member's own by default; the counselor
   * sidebar on a shared report says what it answers from instead.
   */
  @Input() public subtitle =
    'AI advising support to help you make career and education decisions';
  /** S.6. The counselor sidebar has no full-screen mode, so no expand button. */
  @Input() public canExpand = true;

  @Output() public toggleFullScreen = new EventEmitter<void>();
  @Output() public closeChat = new EventEmitter<void>();

  public onToggleFullScreen(): void {
    this.toggleFullScreen.emit();
  }

  public close(): void {
    this.closeChat.emit();
  }
}
